'use client';

import { type JSX } from 'react';

import { Alert } from '@videoblocks/storywind';

import { LoginErrorType, useLoginForm } from './LoginFormContext';

export const LoginErrorBanner = (): JSX.Element | null => {
    const { loginErrorType } = useLoginForm();

    if (loginErrorType === LoginErrorType.RATE_LIMIT_EXCEEDED) {
        return (
            <Alert severity="error" className="w-full text-center">
                We&apos;ve detected several failed attempts to log in to your account, resulting in a temporary account
                lockout. Wait a while before trying again, or contact{' '}
                <a href="mailto:support@storyblocks.com" className="text-blue-700 hover:underline">
                    support@storyblocks.com
                </a>
                .
            </Alert>
        );
    }

    if (loginErrorType) {
        return (
            <Alert severity="error" className="w-full text-center">
                Oops! We don&apos;t recognize that username or password. If you forgot your password or are having
                trouble logging in, please{' '}
                <a href="/password/request-reset" className="text-blue-700 hover:underline">
                    reset your password
                </a>
                .
            </Alert>
        );
    }

    return null;
};
